
    import {useStore} from "@/store";
    import common from "@/util/common";
    import reportMsgUt from "@/util/reportMsg";
    import DetectPlayer from '@/views/components/ALvideoPlayer/index.vue';
    import '@souche-ui/cyp_aliyunplayer/lib/styles/index.css';
    import {useRouter, useRoute} from "vue-router";
    import {defineComponent, computed, ComputedRef, watch, reactive, toRefs} from "vue";
    import {getVideoPlayAuth} from '@/service'
    interface State {
        playAuth: string;
        loopVideo: any;
        videoId: string;
        playData: any;
        reportMsg: object;
        videoInfo: object[];
    }

    export default defineComponent({
        name: "LoopCarVideoH5",
        props: {
            renderData: {
                type: Object,
                default: () => {
                    return {}
                }
            }
        },
        setup(props: any) {
            let state: State = reactive({
                playAuth: '',
                loopVideo: {},
                videoId: '',
                playData: null,
                reportMsg: {},
                videoInfo: [],
            })
            let store = useStore()
            const router = useRouter();
            const {query} = useRoute();
            const {templateCode} = query;
            let reportData: ComputedRef<{}> = computed<{}>(() => store.state.reportData)
            
            state.reportMsg = reportMsgUt;
            const getPlayAuth = function (videoId) {
                videoId && getVideoPlayAuth({videoId}).then((res: any) => {
                    state.playAuth = res;
                    state.playData = {
                        playAuth: res,
                        vodId: state.videoId,
                        cover: state.loopVideo && state.loopVideo.videoFirstImg,
                        autoplay: false,
                        size: state.loopVideo && state.loopVideo.videoSize
                    }
                });
            };
            watch(reportData, (data: any) => {
                const {videoInfo} = data
                state.loopVideo = videoInfo && videoInfo[0];
                state.videoId = state.loopVideo && state.loopVideo.videoId;
                getPlayAuth(state.videoId);
                // console.log('videoId:', state.videoId);
                state.videoInfo = videoInfo;
            }, {immediate: true, deep: true})
            return {
                state,
                router,
                store,
                getPlayAuth
            }
        },
        components: {
            DetectPlayer
        },
        methods: {
            
        }
    })
